import { FaRegCircle, FaCircle } from 'react-icons/fa6';

export default function CMotivator(props) {
   const { page, data,motivator,setValue,value,showValidations } = props;
   function onSetValue(e) {
      let value = parseInt(e.currentTarget.getAttribute("data-value"));
      setValue(motivator.id, value)
   }
   const style = (showValidations && !value) ? "invalid" : "";
   return (
      <tr key={motivator.id} className={style} data-page={page}>
         <td className="description columndata textColumn right" data-column="1">
            <div className="description">{motivator.description}</div>
         </td>
         <td className={`check columndata clickableArea ${value===1? "checked":""}`} title={data.headers[1]} data-value="1" onClick={onSetValue}>
            {value === 1 ?
               <FaCircle className="actionIcon" /> :
               <FaRegCircle className="actionIcon" />
            }
         </td>
         <td className={`check columndata clickableArea ${value === 2 ? "checked" : ""}`} title={data.headers[2]} data-value="2" onClick={onSetValue}>
            {value === 2 ?
               <FaCircle className="actionIcon" /> :
               <FaRegCircle className="actionIcon" />
            }
         </td>
         <td className={`check columndata clickableArea ${value === 3 ? "checked" : ""}`} title={data.headers[3]} data-value="3" onClick={onSetValue}>
            {value === 3 ?
               <FaCircle className="actionIcon" /> :
               <FaRegCircle className="actionIcon" />
            }
         </td>
         <td className={`check columndata clickableArea ${value === 4 ? "checked" : ""}`} title={data.headers[4]} data-value="4" onClick={onSetValue}>
            {value === 4 ?
               <FaCircle className="actionIcon" /> :
               <FaRegCircle className="actionIcon" />
            }
         </td>
      </tr>
   );
}
